/* eslint-disable node/prefer-global/process */

// Read about how to use T3 Env
// https://env.t3.gg/docs/introduction

import { createEnv } from '@t3-oss/env-nextjs'
import z from 'zod'

export const env = createEnv({
  server: {
    NODE_ENV: z.enum(['development', 'test', 'production']).default('development'),
    DATABASE_URL: z.string().min(1),
    INTERVIEW_DATABASE_URL: z.string().min(1),
    BETTER_AUTH_SECRET: z.string().min(1),
    TELEGRAM_BOT_TOKEN: z.string().min(1),
    REVALIDATE_SECRET: z.string().min(1),
    NOTION_WIKI_PAGE_ID: z.string().min(1),
    NOTION_VIDEOS_PAGE_ID: z.string().min(1),
    NOTION_ACTIVE_USER: z.string().min(1).optional(),
    NOTION_TOKEN_V2: z.string().min(1).optional(),
    TOOLSY_PROJECT_ID: z.string().min(1),
    TOOLSY_API_KEY: z.string().min(1),
    S3_UPLOAD_BUCKET: z.string().min(1),
    S3_UPLOAD_ACCESS_KEY_ID: z.string().min(1),
    S3_UPLOAD_SECRET_ACCESS_KEY: z.string().min(1),
    S3_UPLOAD_ENDPOINT: z.string().min(1).optional(),
    S3_UPLOAD_REGION: z.string().min(1),
    NOCODB_API_URL: z.string().url(),
    NOCODB_API_TOKEN: z.string().min(1),
    NOCODB_FEEDBACK_TABLE_ID: z.string().min(1),
    NOCODB_WHITELIST_TABLE_ID: z.string().min(1),
    SMTP_HOST: z.string().min(1),
    SMTP_PORT: z.coerce.number(),
    SMTP_USER: z.string().min(1),
    SMTP_PASS: z.string().min(1),
    SMTP_FROM: z.string().min(1),
  },
  client: {
    NEXT_PUBLIC_NODE_ENV: z.enum(['development', 'test', 'production']).default('development'),
    NEXT_PUBLIC_TELEGRAM_BOT_USERNAME: z.string().min(1),
    NEXT_PUBLIC_BETTER_AUTH_URL: z.string().url(),
    NEXT_PUBLIC_CDN_URL: z.string().url().optional(),
    NEXT_PUBLIC_DISABLE_CDN: z.enum(['true', 'false', '']).optional(),
  },
  experimental__runtimeEnv: {
    NEXT_PUBLIC_NODE_ENV: process.env.NODE_ENV,
    NEXT_PUBLIC_TELEGRAM_BOT_USERNAME: process.env.NEXT_PUBLIC_TELEGRAM_BOT_USERNAME,
    NEXT_PUBLIC_BETTER_AUTH_URL: process.env.NEXT_PUBLIC_BETTER_AUTH_URL,
    NEXT_PUBLIC_CDN_URL: process.env.NEXT_PUBLIC_CDN_URL,
    NEXT_PUBLIC_DISABLE_CDN: process.env.NEXT_PUBLIC_DISABLE_CDN,
  },
})
